import { Link } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import './ManagePharmacyBranch.css';

const ManagePharmacyBranch = () => {
  return (
    <div className="layout"> {/* This will be a flex container */}
      <Sidebar /> {/* Sidebar on the left */}

      <div className="main-content"> {/* Content on the right */}
       
        <div className="card">
          <h1 className="title">🏪 Pharmacy Branch Management</h1>

          <div className="button-grid">
            <Link to="/CreatePharmacyBranch" className="btn">
              ➕ Create New Branch
            </Link>
            <Link to="/PharmacyBranches" className="btn">
              📋 View All Branches
            </Link>
            {/* <Link to="/branches/search" className="btn">
              🔍 Search Branches
            </Link>
            <Link to="/branches/opening-hours" className="btn">
              📆 Manage Opening Hours
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagePharmacyBranch;
